var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.contacts),function(contact,index){return _c('div',{key:index},[_vm._v(_vm._s(_vm.contactType(contact.contact_group,contact.contact_type))+": "+_vm._s(_vm.formatContact(contact)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }